"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canMoveStage = exports.getClosedLostStage = exports.bulkClosedLostEnabled = exports.isBETPortal = void 0;

var _BETDealPermissions = require("crm_data/BET/permissions/BETDealPermissions");

var BETMoveStageCheck = function BETMoveStageCheck(pipeline, prevStage, nextStage, scopes) {
  var includeWarning = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  return (0, _BETDealPermissions.canMoveStage)(pipeline, prevStage, nextStage, scopes, includeWarning);
};

var isBETPortal = function isBETPortal(scopes) {
  return scopes.has('bet-enforce-deal-stage-restrictions');
};

exports.isBETPortal = isBETPortal;

var bulkClosedLostEnabled = function bulkClosedLostEnabled(scopes) {
  return isBETPortal(scopes);
};

exports.bulkClosedLostEnabled = bulkClosedLostEnabled;

var getClosedLostStage = function getClosedLostStage(pipeline) {
  return (0, _BETDealPermissions.closedLostStage)(pipeline);
};

exports.getClosedLostStage = getClosedLostStage;

var canMoveStage = function canMoveStage(pipeline, prevStage, nextStage, scopes) {
  var includeWarning = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

  if (isBETPortal(scopes)) {
    return BETMoveStageCheck(pipeline, prevStage, nextStage, scopes, includeWarning);
  }

  return true;
};

exports.canMoveStage = canMoveStage;